import { getColorScaleObject } from './lib';

const grays = getColorScaleObject('#8b8b8b');
const reds = getColorScaleObject('#ff6361');
const blues = getColorScaleObject('#2B5EF2');
const greens = getColorScaleObject('#1A8828');
const golds = getColorScaleObject('#ffa600');
const yellows = getColorScaleObject('#ffd500');
const purples = getColorScaleObject('#8250df');
const white = '#FFFFFF';
const black = grays[850];

const dataColors = {
  text: { light: greens[75], primary: greens[450], dark: greens[800] },
  markdown: { light: reds[100], primary: reds[500], dark: reds[800] },
  image: { light: blues[100], primary: blues[500], dark: blues[800] },
  video: { light: reds[100], primary: reds[500], dark: reds[800] },
  audio: { light: golds[100], primary: golds[500], dark: golds[800] },
  tabular: { light: purples[100], primary: purples[500], dark: purples[800] },
  binary: { light: grays[100], primary: grays[500], dark: grays[800] },
  directory: { light: grays[100], primary: grays[500], dark: grays[800] },
  dir: { light: grays[100], primary: grays[500], dark: grays[800] },
  application: { light: grays[100], primary: grays[500], dark: grays[800] },
  unknown: { light: grays[100], primary: grays[500], dark: grays[800] },
};

const colors = {
  // gray: grays,
  // green: greens,
  // red: reds,
  // blue: blues,
  // gold: golds,
  // yellow: yellows,
  // purple: purples,
  primary: { white: white, black: black, subtleText: grays[600] },
  secondary: {
    darkGray1: grays[850],
    lightGray1: grays[25],
    lightGray2: grays[100],
    lightGray3: grays[250],
    mediumGray: grays[500],
    blue1: blues[50],
    blue2: blues[500],
    blue3: blues[650],
  },
  data: dataColors,
  semantic: {
    white: { light: white, primary: grays[500], dark: grays[700] },
    positive: { light: greens[50], primary: greens[500], dark: greens[650] },
    notice: { light: yellows[100], primary: yellows[500], dark: yellows[650] },
    negative: { light: reds[100], primary: reds[500], dark: reds[700] },
    information: { light: blues[50], primary: blues[500], dark: blues[700] },
    default: { light: grays[100], primary: grays[500], dark: grays[800] },
    brand: { light: purples[100], primary: purples[500], dark: purples[700] },
    link: blues[650],
    focusBorder: blues[650],
    selectOption: {
      focused: { background: blues[25], color: black },
      selected: { background: blues[100], color: black },
      disabled: { background: grays[100], color: grays[500] },
    },
    pagination: {
      border: grays[100],
      active: { background: blues[500], color: white },
      hover: { background: blues[100], color: 'inherit' },
      disabled: { background: 'inherit', color: grays[250] },
    },
    mergeStatus: { open: greens[450], closed: reds[600], merged: purples[500], conflict: reds[800] },
    placeholder: grays[650],
    disabled: grays[250],
    diff: {
      added: { background: greens[50], highlight: greens[100], indicator: greens[550] },
      removed: { background: reds[50], highlight: reds[200], indicator: reds[700] },
      modified: { background: golds[50], highlight: golds[250], indicator: golds[600] },
    },
  },
};

export default colors;
